import React from 'react'
import Text from '../../atoms/Text'
import { ReactComponent as Edit } from '../../../assets/icons/edit_green.svg'
import { ReactComponent as AddressPin } from '../../../assets/icons/address-pin.svg'
import { useSelector } from 'react-redux'

const AddressInfo = ({ onPressEdit = () => {} }) => {
  const { formFields } = useSelector((s) => s.formPayload)

  return (
    <div className="flex flex-col gap-4 px-4 py-1">
      <div className="w-full flex flex-row items-center justify-between">
        <Text
          tag={'p'}
          variant={'title'}
          size={'medium'}
          className={'text-text-primary'}
        >
          Address Details
        </Text>
        <button
          onClick={onPressEdit}
          className="flex flex-row items-center gap-[2px]"
        >
          <Text
            tag={'p'}
            variant={'label'}
            size={'large'}
            bold={'true'}
            className={'text-text-brand-tertiary'}
          >
            Edit
          </Text>
          <Edit className="min-h-4 min-w-4" />
        </button>
      </div>
      <div className="bg-WHITE p-4 rounded-4 flex flex-row gap-3 items-center">
        <AddressPin className="min-h-10 min-w-10" />
        <Text
          tag={'p'}
          variant={'label'}
          size={'medium'}
          className={'text-text-primary'}
        >
          {formFields?.addressPayload?.address},{' '}
          {formFields?.addressPayload?.landmark},{' '}
          {formFields?.addressPayload?.street},{' '}
          {formFields?.addressPayload?.pincode}
        </Text>
      </div>
    </div>
  )
}

export default AddressInfo
